import {IDescriptionFieldMapping} from "../../../global/utils/DescriptionManager";
import {IOfficer} from "../../../api/Officer/Officer.types";

export const OFFICER_DETAILS_FIELD_MAP:Record<string, IDescriptionFieldMapping<IOfficer>> = {

    id: {
        titleDisplay: "Internal FAMR ID"
    },
    name: {
        hide:true,
    }

}